<template>
  <div class="page-container">
    <div class="header">
      <div class="title">接收方管理</div>
    </div>
    <div class="search-form">
      <el-form
        class="search-form-content"
        inline
        :model="form"
        label-width="120px"
        label-position="left">
        <el-row>
          <el-col :span="6">
            <el-form-item label="商户编号/名称" size="small">
              <el-input v-model="form.saMerchantIdOrName" placeholder="请输入商户编号/名称" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="分账服务状态" size="small">
              <el-select v-model="form.saServiceStatus">
                <el-option :value="0" label="正常"/>
                <el-option :value="1" label="冻结"/>
                <el-option :value="2" label="注销"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建时间" size="small">
              <el-date-picker
                v-model="dateTimeRange"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                align="right"
                size="small"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="账户开户状态" size="small">
              <el-select v-model="form.saOpenStatus">
                <el-option :value="1" label="未开户"/>
                <el-option :value="2" label="已开户"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item size="small">
              <el-button type="primary" @click="handleAdd" class="bs-btn">新增接收方</el-button>
              <el-button type="primary" @click="handleFormSearch" class="bs-btn" :loading="table.loading">查询</el-button>
              <el-button @click="handleFormReset" class="bs-btn2">重置</el-button>
              <el-button type="primary" @click="exportTable" class="bs-btn" :loading="exportLoading">导出</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="table-container">
      <el-table :data="table.data" style="width: 100%;" border v-loading="table.loading">
        <el-table-column prop="receiverMerchantId" label="商户编号" align="center" min-width="150px"/>
        <el-table-column prop="receiverMerchantName" label="商户名称" align="center" min-width="250px"/>
        <el-table-column prop="bankHolder" label="开户名称" align="center" min-width="250px"/>
        <el-table-column prop="bankName" label="开户银行" align="center" min-width="250px"/>
        <el-table-column prop="bankCardNo" label="银行卡号" align="center" min-width="250px"/>
        <el-table-column prop="accountProcessStr" label="账户开户状态" align="center" min-width="150px"/>
        <el-table-column prop="managerStateStr" label="分账服务状态" align="center" min-width="150px"/>
        <el-table-column prop="createTime" label="创建时间" align="center" min-width="200px"/>
        <el-table-column label="操作" align="center" fixed="right" min-width="200px">
          <template slot-scope="{row}">
            <el-button class="copy" type="text" v-if="row.url" @click="handleViewDetail(row)">详情</el-button>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-content">
        <el-pagination
          v-if="table.totalCount > 0"
          :page-size="table.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="table.totalCount"
          :current-page="table.pageNo"
          @current-change="onChangeCurrentPage"/>
      </div>
    </div>
    <el-dialog title="云管家（分账）平台接收方添加" :visible.sync="showAddDialog" width="800px" center @close="handleAddDialogCancel">
      <el-form
        v-if="active === 0"
        ref="addDialogFormRef"
        :model="addDialogForm"
        :rules="addDialogRules"
        style="width: 100%;margin-top: 20px;"
        size="small"
        label-width="100px">
        <el-form-item label="账户类型" prop="merchantId">
          <el-select v-model="addDialogForm.subjectType">
            <el-option :value="1" label="个人"/>
            <el-option :value="2" label="个体"/>
            <el-option :value="3" label="企业"/>
          </el-select>
        </el-form-item>
        <el-form-item label="证件号码" prop="subjectId">
          <el-input v-model="addDialogForm.subjectId" placeholder="请输入证件号码" maxlength="18" clearable/>
          <p>证件号码：账户类型是个人时为身份证编号，账户类型是个体或企业为营业执照编号</p>
        </el-form-item>
      </el-form>
      <template v-else>
        <div class="process-content">
          <div v-for="(item, index) in processArr" :key="index">
            <img :src="require(`@/assets/images/cloud-manage/receiver-${item.icon}-icon.png`)"/>
            <p v-for="(cItem, cIndex) in item.text" :key="cIndex">{{ cItem }}</p>
          </div>
        </div>
        <el-input v-model="addDialogForm.url">
          <el-button slot="append" class="copy1" @click="copyText(addDialogForm.url, '.copy1')">复制专属链接</el-button>
        </el-input>
      </template>
      <div slot="footer">
        <el-button type="primary" class="bs-btn" @click="handleAddDialogCancel">关闭</el-button>
        <el-button type="primary" class="bs-btn" @click="handleAddDialogConfirm" v-if="active === 0" :loading="addDialogLoading">生成邀请链接</el-button>
      </div>
    </el-dialog>
    <!-- copilot begin -->
    <el-dialog title="详情" :visible.sync="showDetailDialog" width="400px" center>
      <div class="detail-dialog">
        <div class="detail-info">
          <div class="detail-item">
            <span class="detail-label">状态:</span>
            <span class="detail-value">{{ detailInfo.accountProcessStr }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">开户类型:</span>
            <span class="detail-value">{{ getSubjectTypeText(detailInfo.subjectType) }}</span>
          </div>
          <div class="detail-item" v-if="detailInfo.receiverMerchantId">
            <span class="detail-label">商户名称:</span>
            <span class="detail-value">{{ detailInfo.receiverMerchantName }}</span>
          </div>
          <div class="detail-item" v-if="detailInfo.receiverMerchantId">
            <span class="detail-label">商户编号:</span>
            <span class="detail-value">{{ detailInfo.receiverMerchantId }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">证件号码:</span>
            <span class="detail-value">{{ detailInfo.subjectNo }}</span>
          </div>
          <!-- 显示开户二维码（仅在开户中状态时显示） -->
          <div class="detail-item qrcode-item" v-if="isOpeningAccount">
            <span class="detail-label">开户二维码:</span>
            <div class="qrcode-wrapper">
              <div id="detail-qrcode"></div>
              <div class="qrcode-actions">
                <el-button type="primary" size="mini" class="bs-btn copy-btn" @click="copyText(detailInfo.url)">复制专属链接</el-button>
                <el-button type="primary" size="mini" class="bs-btn" @click="downloadQRCode">下载二维码</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- copilot end -->
  </div>
</template>

<script>
import Clipboard from "clipboard";
import QRCode from "qrcodejs2";
import { exportReceiverBind, queryListReceiverBind, getReceiveToken } from '@/api/cloud-manage';
import { debounce } from "@/utils/index";


export default {
  name: "receiver",
  data() {
    return {
      dateTimeRange: [],
      form: {
        saMerchantIdOrName: '',
        saServiceStatus: '',
        saOpenStatus: '',
      },
      table: {
        loading: false,
        data: [],
        pageNo: 1,
        totalCount: 0,
        pageSize: 10,
      },
      exportLoading: false,
      showAddDialog: false,
      addDialogLoading: false,
      addDialogForm: {
        subjectType: 1,
        subjectId: '',
        url: '',
      },
      addDialogRules: {
        subjectId: [{ required: true, message: "请输入证件号码", trigger: ['blur', 'change'] }],
      },
      active: 0,
      processArr: [
        { icon: 'copy', text: ['复制专属链接'] },
        { icon: 'link', text: ['分享链接', '至接收方'] },
        { icon: 'open', text: ['接收方打开链接', '完成注册'] },
        { icon: 'bind', text: ['关系绑定成功', '可提交分账计划'] },
      ],
      // 详情弹窗相关数据
      showDetailDialog: false,
      detailInfo: {},
      qrcodeInstance: null,
    };
  },
  computed: {
    exportTable() {
      return debounce(this.exportTableFunc, 500, true);
    },
    // 判断是否为开户中状态
    isOpeningAccount() {
      return this.detailInfo.accountProcess === '1' || this.detailInfo.accountProcessStr === '开户中';
    },
  },
  mounted() {
    this.handleFormSearch();
  },
  methods: {
    handleAdd() {
      this.showAddDialog = true;
    },
    handleFormSearch() {
      this.table.pageNo = 1;
      this.queryTableData();
    },
    handleFormReset() {
      this.form = {
        saMerchantIdOrName: '',
        saServiceStatus: '',
        saOpenStatus: '',
      };
      this.dateTimeRange = [];
      this.handleFormSearch();
    },
    setParameter(callback) {
      const [startTime, endTime] = this.dateTimeRange || [];
      const { pageNo, pageSize } = this.table;
      const params = {
        ...this.form,
        startTime,
        endTime,
        pageNo,
        pageSize,
      };
      callback(params);
    },
    queryTableData() {
      this.setParameter(async (params) => {
        this.table.loading = true;
        const { data: { data: { list, totalCount } } } = await queryListReceiverBind(params).finally(() => {
          this.table.loading = false;
        });
        this.table.data = list;
        this.table.totalCount = totalCount;
      });
    },
    /**
     * 改变当前页事件
     * @param  {number} pageNo 当前页码
     */
    onChangeCurrentPage(pageNo) {
      this.table.pageNo = pageNo;
      this.queryTableData();
    },
    exportTableFunc() {
      this.setParameter((params) => {
        this.exportLoading = true;
        exportReceiverBind(params).finally(() => {
          this.exportLoading = false;
        });
      });
    },
    copyText(text, target) {
      const selector = target || '.copy-btn';
      const clipboardOptions = {
        text: () => text,
      };
      const clipboard = new Clipboard(selector, clipboardOptions);
      clipboard.on('success', () => {
        this.$message.success('复制成功');
        clipboard.destroy();
      });
      clipboard.on('error', () => {
        this.$message.error('复制失败');
        clipboard.destroy();
      });
    },
    // 查看详情
    handleViewDetail(row) {
      this.detailInfo = { ...row };
      this.showDetailDialog = true;
      this.$nextTick(() => {
        this.generateQRCode(row.url);
      });
    },
    // 生成二维码
    generateQRCode(url) {
      if (document.getElementById('detail-qrcode')) {
        document.getElementById('detail-qrcode').innerHTML = '';
        this.qrcodeInstance = new QRCode(document.getElementById('detail-qrcode'), {
          width: 180,
          height: 180,
        });
        this.qrcodeInstance.clear();
        this.qrcodeInstance.makeCode(url);
      }
    },
    // copilot begin
    // 下载二维码
    downloadQRCode() {
      const qrcodeImg = document.getElementById("detail-qrcode").getElementsByTagName('img')[0];
      if (!qrcodeImg) {
        this.$message.error('二维码图片未生成');
        return;
      }
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = 240;
      canvas.height = 240;
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      const qrSize = 200;
      const offsetX = (canvas.width - qrSize) / 2;
      const offsetY = (canvas.height - qrSize) / 2;
      ctx.drawImage(qrcodeImg, offsetX, offsetY, qrSize, qrSize);
      const imageURL = canvas.toDataURL('image/png');
      const a = document.createElement('a');
      a.href = imageURL;
      a.download = `开户二维码_${this.detailInfo.receiverMerchantId || '接收方'}.png`;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      this.$message.success('二维码下载成功');
    },
    // copilot end
    getSubjectTypeText(type) {
      const typeMap = {
        1: '个人',
        2: '个体',
        3: '企业',
      };
      return typeMap[type] || '-';
    },
    handleAddDialogCancel() {
      this.showAddDialog = false;
      this.active = 0;
      this.addDialogForm = {
        subjectType: 1,
        subjectId: '',
        url: '',
      };
    },
    handleAddDialogConfirm() {
      this.$refs.addDialogFormRef.validate((valid) => {
        if (valid) {
          this.addDialogLoading = true;
          const { subjectType, subjectId } = this.addDialogForm;
          getReceiveToken({ subjectType, subjectId, jumpUrl: '' }).then(({ data: { data: { url } } }) => {
            this.addDialogForm.url = url;
            this.active = 1;
          }).finally(() => {
            this.addDialogLoading = false;
          });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.page-container {
  > .header {
    padding-left: 50px;
    background-color: #fff;

    .title {
      position: relative;
      height: 80px;
      font-size: 18px;
      line-height: 80px;
      color: #333;

      &::after {
        position: absolute;
        right: 0;
        bottom: 0;
        left: -50px;
        display: block;
        height: 0;
        content: "";
        border-bottom: 1px solid #f2f3f3;
      }
    }
  }

  .search-form {
    padding: 40px 50px 20px;
    border-bottom: 20px solid #eee;

    .search-form-content {
      /deep/ .el-select,
      /deep/ .el-input {
        width: 210px;
      }
    }
  }

  .table-container {
    padding: 40px 50px 0;
    background: #fff;

    .pagination-content {
      margin-top: 10px;
      text-align: center;
    }
  }

  .avatar-uploader {
    /deep/ .el-upload {
      position: relative;
      overflow: hidden;
      cursor: pointer;
      border: 1px dashed #d9d9d9;
      border-radius: 6px;

      &:hover {
        border-color: #409eff;
      }
    }

    .avatar-uploader-icon {
      width: 178px;
      height: 178px;
      font-size: 28px;
      line-height: 178px;
      color: #8c939d;
      text-align: center;
    }

    .avatar {
      display: block;
      width: 178px;
      height: 178px;
    }
  }

  .process-content {
    display: flex;
    justify-content: space-between;
    margin-bottom: 40px;

    & > div {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100px;

      &:not(:last-child)::after {
        position: absolute;
        top: 15px;
        right: -39px;
        display: block;
        width: 28px;
        height: 10px;
        content: "";
        background-image: url(../../../assets/images/cloud-manage/receiver-process-bg.png);
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
      }

      img {
        width: 40px;
        margin-bottom: 16px;
      }

      p {
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        color: #303133;
        text-align: center;
      }
    }
  }

  // 详情弹窗样式
  .detail-dialog {
    .detail-info {
      padding: 20px;
      .detail-item {
        margin-bottom: 15px;
        line-height: 24px;
        display: flex;
        align-items: flex-start;
        .detail-label {
          display: inline-block;
          width: 100px;
          font-weight: bold;
          color: #606266;
        }
        .detail-value {
          flex: 1;
        }
        &.qrcode-item {
          align-items: center;
          margin-bottom: 5px;
          .qrcode-wrapper {
            display: flex;
            flex-direction: column;
            align-items: center;
            #detail-qrcode {
              display: inline-block;
              padding: 5px;
              background: #fff;
              border: 1px solid #EBEEF5;
              border-radius: 4px;
              margin-bottom: 15px;
            }
            .qrcode-actions {
              display: flex;
              justify-content: center;
              gap: 10px;
              .bs-btn {
                margin: 0;
              }
            }
          }
        }
      }
    }
    .detail-actions {
      display: flex;
      justify-content: center;
      margin-top: 20px;
      .bs-btn {
        margin: 0 10px;
      }
    }
  }
}
</style>
